import axios from "@/common/http.js";
import router from "@/router/index.js";
var actions = {
  async getMsgCode({ commit }, tel) {
    console.log(tel, "设置");
    commit("setData", {
      face: tel
    });
  },
  // 获取用户信息
  async getuserinfo({ commit, dispatch }, { tel, type = "no" }) {
    let { code, data, msg, info } = await axios({
      url: "index/user.User/getUserInfo",
      method: "get",
      params: {
        username: tel
      }
    });
    if (code == "10001") {
      window.localStorage.setItem("unionid", data[0].unionid);
      commit("setData", data[0]);
      window.localStorage.setItem("userid", data[0].userid);
      window.localStorage.setItem("username", data[0].username);
      window.localStorage.setItem("nickname", data[0].nickname);
      window.localStorage.setItem("face", data[0].face);
      console.log("存储学校id", data[0].schoolid);
      window.localStorage.setItem("schoolid", data[0].schoolid);
      window.localStorage.setItem("schoolname", data[0].schoolname);
      window.localStorage.setItem("adminrolename", data[0].adminrolename);
      window.localStorage.setItem("adminroleid", data[0].adminroleid);

      dispatch(
        "xiaoben/getplatarr",
        { schoolid: data[0].schoolid, userid: data[0].userid },
        { root: true }
      );
      dispatch("setting/getxueduan", "", { root: true });
      dispatch(
        "xiaoben/getplatarr",
        { schoolid: data[0].schoolid },
        { root: true }
      );
      dispatch(
        "department/getuserDepatment",
        { userid: data[0].userid },
        { root: true }
      );
      if (data[0].adminrole != "") {
        window.localStorage.setItem(
          "rules",
          JSON.stringify(JSON.parse(data[0].adminrole["rule"]))
        );
      } else {
        let arr = [];
        window.localStorage.setItem("rules", JSON.stringify(arr));
      }
      let dataPre = {
        infoname: data[0].infoname,
        infoid: data[0].infoid
      };
      if (dataPre.infoid == "") {
        dataPre = {
          infoname: "小学,语文,人民教育出版社,一年级上册",
          infoid: "1,1,1,1"
        };
      }

      if (dataPre.infoid != "") {
        window.localStorage.setItem("infoid", dataPre.infoid);
        window.localStorage.setItem("infoname", dataPre.infoname);
        let chapterides = {
          xueduan_id: dataPre.infoid.split(",")[0],
          subject_id: dataPre.infoid.split(",")[1],
          version_id: dataPre.infoid.split(",")[2],
          cebie_id: dataPre.infoid.split(",")[3]
        };
        dispatch("xiaoben/getchapterlistsk", chapterides, { root: true });
        dispatch("xiaoben/getchapterlist", chapterides, { root: true });
        let chapteridesarr = dataPre.infoid.split(",");
        let showchapterides = [
          dataPre.infoid.split(",")[0] + dataPre.infoname.split(",")[0],
          dataPre.infoid.split(",")[1] + dataPre.infoname.split(",")[1],
          dataPre.infoid.split(",")[2] + dataPre.infoname.split(",")[2],
          dataPre.infoid.split(",")[3] + dataPre.infoname.split(",")[3]
        ];
        let chapteridname = dataPre.infoname.split(",").join("/");
        let chapterid =
          dataPre.infoid.split(",")[0] + dataPre.infoname.split(",")[0];
        let xkname =
          dataPre.infoname.split(",")[0] + "/" + dataPre.infoname.split(",")[1];
        let xk = {
          xueduan_id: dataPre.infoid.split(",")[0],
          subject_id: dataPre.infoid.split(",")[1]
        };
        let zjcheck = [
          dataPre.infoid.split(",")[2] + dataPre.infoname.split(",")[2],
          dataPre.infoid.split(",")[3] + dataPre.infoname.split(",")[3]
        ];
        let zjname =
          dataPre.infoname.split(",")[2] + "/" + dataPre.infoname.split(",")[3];
        let zjid = [dataPre.infoid.split(",")[2], dataPre.infoid.split(",")[3]];
        commit(
          "xiaoben/setSetdata",
          {
            key: "xkname",
            data: xkname
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "xk",
            data: xk
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "zjname",
            data: zjname
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "zjcheck",
            data: zjcheck
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "chapterides",
            data: chapterides
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "chapteridesarr",
            data: chapteridesarr
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "showchapterides",
            data: showchapterides
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "showchapterides",
            data: showchapterides
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "chapteridname",
            data: chapteridname
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "chapterid",
            data: chapterid
          },
          { root: true }
        );
        //授课
        commit(
          "xiaoben/setSetdata",
          {
            key: "skchapterid",
            data: chapterid
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "skchapterides",
            data: chapterides
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "skchapteridesarr",
            data: chapteridesarr
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "skshowchapterides",
            data: showchapterides
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "skshowchapterides",
            data: showchapterides
          },
          { root: true }
        );
        commit(
          "xiaoben/setSetdata",
          {
            key: "skchapteridname",
            data: chapteridname
          },
          { root: true }
        );
      }
      if (type == "modular") {
        router.replace(`/index/modular`);
      }
    } else {
    }
  },
  // 获取shenhe信息
  async shenheStatus({ commit }, _this) {
    let { code, data } = await axios({
      url: "index/index/checkUserStatus",
      method: "get",
      params: {
        userid: window.localStorage.getItem("userid")
      }
    });
    return new Promise((resolve, reject) => {
      resolve(code);
    });
    // if(code=='40003'){
    // 	 console.log('补充信息')
    // 	 window.sessionStorage.setItem('status',1)
    // 	 _this.$router.replace(`/index/modular`);
    // }else if(code=='40004'){
    // 	 console.log('审核中')
    // 	 window.sessionStorage.setItem('status',2)
    // 	 _this.$router.replace(`/index/modular`);
    // }else{
    // 	console.log('tongguo')
    // 	window.sessionStorage.removeItem('status')
    // }
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/user/action.js